import * as api from '../../../api'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { ALERT } from '../../../constants/actionTypes'

import Project from '../Project/Project'

import Word from '../../../images/documents/word.png'
import Excel from '../../../images/documents/excel.png'
import PowerPoint from '../../../images/documents/powerpoint.png'
import Pdf from '../../../images/documents/pdf.png'
import Image from '../../../images/documents/image.png'
import General from '../../../images/documents/general.png'

import './Ongoing.css'

const Ongoing = ({ user, fetching }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [quotes, setQuotes] = useState([])
    const [quote, setQuote] = useState({})
    const [showDetails, setShowDetails] = useState(false)

    const getQuotes = useCallback(async () => {
        if(!user) return false        
        if (user && !user.workPlace) setLoading(false)
        if(user.workPlace) {
            try {
                const { data } = await api.getProjects(user.workPlace.ongoing_projects)
                setQuotes(data)
            } catch (error) {
                if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
                else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
            } finally {
                setLoading(false)
            }
        }
    }, [user, dispatch])

    const handleDetails = (quote) => {
        setQuote(quote)
        setShowDetails(true)
    }

    const getFileImage = (file) => {
        if(file === 'pdf') return Pdf
        else if(file === 'doc' || file === 'docx') return Word
        else if(file === 'xlsx' || file === 'xls') return Excel
        else if(file === 'pptx' || file === 'ppt') return PowerPoint
        else if(file === 'jpeg' || file === 'jpg' || file === 'png' || file === 'raw') return Image
        else return General
    }

    useEffect(() => {
        if(showDetails) {
            document.getElementsByTagName("BODY")[0].style.overflow = 'hidden'
        } else {
            document.getElementsByTagName("BODY")[0].style.overflow = 'auto'
        }
    }, [showDetails])

    useEffect(() => {
        if(quotes.length === 0) getQuotes()
        else setLoading(false)
    }, [getQuotes, quotes])

    return (
        <>
        {showDetails && <Project showDetails={showDetails} setShowDetails={setShowDetails} quote={quote} ongoing/>}
        <div className="ongoing">
            <h2 className="mb-40 py-20 font-subhead">Ongoing Projects</h2>
            <div className="d-flex flex-wrap">
                {(loading || fetching) ?
                    <div className="loader mx-auto">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                        :
                    <>
                    {quotes.length < 1 && <div className="font-bolder font-bigger text-center w-100">No ongoing project</div>} 
                    {quotes.map((quote, index) =>
                        <div className="client__file d-flex flex-column align-center mr-20 mb-20 box-shadow-lg p-20" key={quote.projectName.concat(index)}>
                            <img src={getFileImage(quote.fileType)} alt="" />
                            <div className="d-flex flex-column align-center justify-center mt-20">
                                <span className="text-capitalise font-heavy font-sm">{quote.projectName}</span>
                                {quote.status === 'active' &&
                                    <span style={{ color: 'blue' }} className="font-bolder">
                                        Activated
                                    </span>
                                }
                                {quote.status === 'ongoing' &&
                                    <span style={{ color: 'orange' }} className="font-bolder">
                                        Ongoing
                                    </span>
                                }
                                {quote.status === 'completed' &&
                                    <span style={{ color: 'green' }} className="font-bolder">
                                        Reveiwing
                                    </span>
                                }
                            </div>
                            <div className="client__file__btn d-flex justify-between mt-20 w-100">
                                <button 
                                  style={{ width: quote.payment.amount === 0 ? '100%' : '' }}
                                  className="font-heavy border-1 outline-0 p-5 w-100" onClick={() => handleDetails(quote)}>Details</button>
                            </div>
                        </div>
                    )}
                    </>
                }
            </div>
        </div>
        </>
    )
}

export default Ongoing
